import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

export const fetchProducts = createAsyncThunk(
  "products/fetchAll",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const token = auth?.access_token;
      const tokenType = auth?.token_type || "Bearer";
      const response = await apiClient.get("/products/19", {
        headers: { Authorization: `${tokenType} ${token}` },
      });
    
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

const initialState = {
  item: {},
  product_code: null,
  status: "idle",
  error: null,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProductCode(state, action) {
      state.product_code = action.payload || null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.item = action.payload ? action.payload : {};
        state.product_code = action.payload?.product_code || action.payload?.code || null;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || "Failed to fetch products";
      });
  },
});

export const { setProductCode } = productsSlice.actions;
export default productsSlice.reducer;



